import React, { useState } from 'react';
import './Insurance.css';
import InsuranceModal from './InsuranceModal';

// Import insurance provider images
import aetnaImg from '../assets/insurances/1.png';
import bcbsImg from '../assets/insurances/2.png';
import cignaImg from '../assets/insurances/3.png';
import uhcImg from '../assets/insurances/4.jpg';
import medicareImg from '../assets/insurances/5.png';
import tricareImg from '../assets/insurances/6.png';
import humanaImg from '../assets/insurances/7.jpg';
import kaiserImg from '../assets/insurances/8.png';

// Insurance provider names and their corresponding images
const insuranceProviders = [
  { name: 'Aetna', img: aetnaImg },
  { name: 'Blue Cross Blue Shield', img: bcbsImg },
  { name: 'Cigna', img: cignaImg },
  { name: 'UnitedHealthcare', img: uhcImg },
  { name: 'Medicare', img: medicareImg },
  { name: 'Tricare', img: tricareImg },
  { name: 'Humana', img: humanaImg },
  { name: 'Kaiser Permanente', img: kaiserImg }
];

const Insurance = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <section className="insurance" id="insurance">
      <div className="container insurance-container" style={{maxWidth : "1400px"}}>
        <div className="insurance-grid">
          {/* Left Column */}
          <div className="insurance-content">
            <div className="shield-icon-circle mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-shield text-primary">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"></path>
              </svg>
            </div>
            <h2>Insurance & Payment</h2>
            <p >
              We accept most major insurance plans, cash, checks, credit/debit cards, and HSA/FSA.
            </p><br></br>
            <p className="insurance-description">
              No subscriptions or membership fees. We do NOT accept Care Credit.
            </p>
            <p className="insurance-description">Contact your insurance company to check your coverage.</p>
            
          </div>

          {/* Right Column */}
          <div className="insurance-providers">
            <h3>Accepted Insurance Providers</h3>
            <div className="providers-grid">
              {insuranceProviders.map((provider, index) => (
                <div className="provider-logo" key={index}>
                  <img 
                    src={provider.img}
                    alt={provider.name}
                    title={provider.name}
                    loading="lazy"
                    style={{
                      maxWidth: '100%',
                      maxHeight: '60px',
                      objectFit: 'contain'
                    }}
                    onError={(e) => {
                      // Fallback to text if image fails to load
                      e.target.style.display = 'none';
                      e.target.parentNode.textContent = provider.name;
                    }}
                  />
                </div>
              ))}
            </div>
            <button className="view-all-btn" onClick={openModal}>
              View All Insurances
            </button>
            <InsuranceModal isOpen={isModalOpen} onClose={closeModal} />
            <p className="disclaimer">
              * Please verify your specific plan coverage with your provider
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Insurance;
